import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, CustomerAccountType, getChildEdgeTypeId } from '@iotv/datamodel-core';
import CustomerVIcon from '@mui/icons-material/AccountBalance';
import CustomerXIcon from '@mui/icons-material/Apartment';
import CustomerYIcon from '@mui/icons-material/Business';
import CustomerZIcon from '@mui/icons-material/House';
import { TypeIcons } from '../../../Iconography';
import { basicAdminViewOnLabelClick, DefaultStepTypeFolderClickWrapper, } from '../../../v2/components/generic/ObjectTree';
const debug = process.env.REACT_APP_DEBUG && false;
/** Group -> Customer */
const GroupToCustomer = {
    stepQuery: {
        objectTypeId: 'Customer',
        adjacencyType: AdjacentType.CHILD,
    },
    endIcon: (vob) => vob?.accountType === CustomerAccountType.Z
        ? CustomerZIcon
        : vob?.accountType === CustomerAccountType.Y
            ? CustomerYIcon
            : vob?.accountType === CustomerAccountType.X
                ? CustomerXIcon
                : vob?.accountType === CustomerAccountType.V
                    ? CustomerVIcon
                    : TypeIcons.Customer,
    thisStepLabelWrapper: basicAdminViewOnLabelClick,
};
/** `Group` -> `Group` (`supportedType`: `Customer`) */
const GroupToGroup = {
    stepQuery: {
        objectTypeId: 'Group',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: getChildEdgeTypeId('Group', 'Group'),
    },
    nodeFilter: (vob) => vob?.supportedType === 'Customer',
    endIcon: TypeIcons.Group,
    nextSteps: [GroupToCustomer],
};
GroupToGroup.nextSteps?.unshift(GroupToGroup);
/** `Customer` -> `Group` (`supportedType`: `Customer`) */
const CustomerToGroup = {
    stepQuery: {
        objectTypeId: 'Group',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: getChildEdgeTypeId('Customer', 'Group'),
    },
    nodeFilter: (vob) => vob?.supportedType === 'Customer',
    endIcon: TypeIcons.Group,
    nextSteps: [],
    renderTypeFolder: false,
    thisStepTypeFolderClickWrapper: (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Customer Groups" }), support: 'Customer' })),
    thisStepLabelWrapper: basicAdminViewOnLabelClick,
};
CustomerToGroup.nextSteps?.push(GroupToCustomer);
CustomerToGroup.nextSteps?.unshift(GroupToGroup);
export const customerCustomerGroupStep = CustomerToGroup;
